var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('page-section',[_c('h3',[_vm._v("studyId: "+_vm._s(_vm.studyId))])]),_c('page-section',[_c('participants-list',{attrs:{"study-id":_vm.studyId}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }